(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ci3d-scooter-comparison"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll('.ci3d-scooter-compare');
    sections.forEach((section) => {
      const viewport = section.querySelector('[data-compare-viewport]');
      const previous = section.querySelector('[data-compare-previous]');
      const next = section.querySelector('[data-compare-next]');
      if (!viewport || !previous || !next) return;

      const currentCard = viewport.querySelector('.ci3d-scooter-card--current');
      if (currentCard) {
        requestAnimationFrame(() => {
          viewport.scrollTo({ left: Math.max(0, currentCard.offsetLeft - 2), behavior: 'auto' });
        });
      }

      const move = (direction) => {
        const card = viewport.querySelector('.ci3d-scooter-card');
        const distance = card ? card.getBoundingClientRect().width + 12 : viewport.clientWidth * 0.8;
        viewport.scrollBy({ left: distance * direction, behavior: 'smooth' });
      };

      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ci3d-tally-quote-embed"] && !Shopify.designMode) return;
  try {
    
  const tallyEmbeds = document.querySelectorAll('.ci3d-tally-quote__iframe[data-tally-src]:not([src])');

  const loadTallyEmbeds = () => {
    if (window.Tally && typeof window.Tally.loadEmbeds === 'function') {
      window.Tally.loadEmbeds();
      return;
    }

    tallyEmbeds.forEach((iframe) => {
      iframe.src = iframe.dataset.tallySrc;
    });
  };

  if (window.Tally && typeof window.Tally.loadEmbeds === 'function') {
    loadTallyEmbeds();
  } else {
    const existingScript = document.querySelector('script[src="https://tally.so/widgets/embed.js"]');

    if (existingScript) {
      existingScript.addEventListener('load', loadTallyEmbeds, { once: true });
    } else {
      const script = document.createElement('script');
      script.src = 'https://tally.so/widgets/embed.js';
      script.async = true;
      script.addEventListener('load', loadTallyEmbeds, { once: true });
      script.addEventListener('error', loadTallyEmbeds, { once: true });
      document.body.appendChild(script);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["createit3dstrip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseTrustStrips = (scope = document) => {
      scope.querySelectorAll('[data-ci3d-trust-strip]').forEach((strip) => {
        if (strip.dataset.reviewBound === 'true') return;
        strip.dataset.reviewBound = 'true';

        const countLabels = strip.querySelectorAll('[data-ci3d-google-count]');
        const googleLink = strip.querySelector('[data-ci3d-google-link]');

        const syncCount = () => {
          const feed = document.querySelector('[numofreviews]');
          const count = Number.parseInt(feed?.getAttribute('numofreviews') || '', 10);
          if (!Number.isFinite(count) || count < 1) return false;

          countLabels.forEach((label) => {
            label.textContent = count + ' ' + strip.dataset.reviewSuffix;
          });
          googleLink?.setAttribute('aria-label', 'Open Create It 3D on Google Maps. ' + count + ' ' + strip.dataset.reviewSuffix + '.');
          strip.dataset.reviewState = 'ready';
          return true;
        };

        if (syncCount()) return;

        const reviewRoot = document.querySelector('#grp-entangle--root') || document.body;
        const observer = new MutationObserver(() => {
          if (syncCount()) observer.disconnect();
        });

        observer.observe(reviewRoot, { attributes: true, attributeFilter: ['numofreviews'], childList: true, subtree: true });

        window.setTimeout(() => {
          if (syncCount()) {
            observer.disconnect();
            return;
          }
          countLabels.forEach((label) => {
            label.textContent = strip.dataset.googleFallback;
          });
          strip.dataset.reviewState = 'fallback';
          observer.disconnect();
        }, 12000);
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialiseTrustStrips(), { once: true });
    } else {
      initialiseTrustStrips();
    }

    document.addEventListener('shopify:section:load', (event) => initialiseTrustStrips(event.target));
  })();

  /* CI3D SERVICE DIRECTORY LINK MAP 2026-07-23 */
  (() => {
    const links = new Map([
      ['3D Printing & Prototyping','/pages/3d-printing-services'],
      ['3D Scanning & Reverse Engineering','/pages/3d-scanning-reverse-engineering'],
      ['Steel/Aluminium Custom Fabrication','/pages/custom-fabrication-structural-components'],
      ['Laser Cutting / Engraving','/pages/laser-cutting-engraving'],
      ['UV / DTF Printing','/pages/uv-dtf-printing-services'],
      ['UV & DTF Printing','/pages/uv-dtf-printing-services'],
      ['Custom Plastic Bags','/pages/custom-plastic-bags']
    ]);
    const clean = (value) => (value || '').replace(/\s+/g,' ').trim();
    const patch = (root = document) => {
      const anchors = root.matches?.('a') ? [root] : [...(root.querySelectorAll?.('a') || [])];
      anchors.forEach((anchor) => {
        const label = clean(anchor.getAttribute('aria-label'));
        const text = clean(anchor.querySelector('.mm-title')?.textContent || anchor.textContent);
        const destination = links.get(label) || links.get(text);
        if (!destination) return;
        anchor.setAttribute('href',destination);
        anchor.setAttribute('data-href',destination);
        anchor.dataset.ci3dServiceLink='true';
      });
    };
    const start = () => {
      patch();
      const observer = new MutationObserver((records) => records.forEach((record) => record.addedNodes.forEach((node) => {
        if (node.nodeType === 1) patch(node);
      })));
      observer.observe(document.body,{childList:true,subtree:true});
      window.setTimeout(() => { patch(); observer.disconnect(); },20000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
    document.addEventListener('shopify:section:load',() => patch());
  })();


  } catch(e) { console.error(e); }
})();
})();
